import { TICK, START_TIMER } from '../actions/types'
import { fetchAllResults } from '../actions/index';



const initialState = {
    isOn: true
  }

const timerReducer = (state = initialState, action) => {
 //   console.log("timer",state,action)
    
    switch (action.type) {
    case START_TIMER:
      return state
 //       console.log("start_timer",state,action)
 //       return Object.assign({}, state, {
 //           results: action.getResults
 //       })
 //     case TICK:
 //       
 //       return Object.assign({}, state, action, {
 //           results: action.getResults
 //       })
    default:
        return state
  }
}

export const timerTick = isOn => {
    return {
      type: 'TICK',
      isOn,
    }
  }

 export const timerMiddleware = store => next => action => {
    if (action.type === 'START_TIMER') {
      
      action.interval = setInterval(() => store.dispatch({ type: TICK, GetResults: store.dispatch(fetchAllResults()) }), 5000);
    } else if (action.type === 'STOP_TIMER') {
      clearInterval(action.interval);
    }
    next(action);
  };

  export default timerReducer